import { render } from "./profile-mobile.vue?vue&type=template&id=578add25&scoped=true&ts=true"
import script from "./profile-mobile.vue?vue&type=script&lang=ts"
export * from "./profile-mobile.vue?vue&type=script&lang=ts"

import "./profile-mobile.vue?vue&type=style&index=0&id=578add25&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-578add25"]])

export default __exports__